import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";

export default function AdminContent() {
  const [about, setAbout] = useState({ title:"", body:"" });
  const [help, setHelp] = useState({ title:"", body:"", extra:{ phone:"", email:"", instagram:"", website:"" } });

  useEffect(() => { api.get("/content/about").then(r=>setAbout(r.data)); api.get("/content/help").then(r=>setHelp({...r.data, extra: r.data.extra || {}})); }, []);

  const saveAbout = async () => { await api.put("/admin/content/about", { key:"about", ...about }); toast.success("About saved"); };
  const saveHelp = async () => { await api.put("/admin/content/help", { key:"help", ...help }); toast.success("Help saved"); };

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="font-display text-3xl font-bold">Content Management</h1>

      <section className="bg-white border border-slate-100 rounded-2xl p-5 space-y-3">
        <h3 className="font-display font-bold">About Us Page</h3>
        <Input value={about.title} onChange={v=>setAbout({...about,title:v})} label="Title" testid="about-title"/>
        <Textarea value={about.body} onChange={v=>setAbout({...about,body:v})} label="Body" testid="about-body" rows={8}/>
        <button data-testid="about-save" onClick={saveAbout} className="btn-primary-sf px-5 py-2 rounded-full text-sm font-semibold">Save</button>
      </section>

      <section className="bg-white border border-slate-100 rounded-2xl p-5 space-y-3">
        <h3 className="font-display font-bold">Help & Support Page</h3>
        <Input value={help.title} onChange={v=>setHelp({...help,title:v})} label="Title" testid="help-title"/>
        <Textarea value={help.body} onChange={v=>setHelp({...help,body:v})} label="Body" testid="help-body"/>
        <div className="grid sm:grid-cols-2 gap-3">
          {["phone","email","instagram","website"].map(k => (
            <Input key={k} label={k} value={help.extra?.[k]||""} onChange={v=>setHelp({...help, extra:{...help.extra,[k]:v}})} testid={`help-${k}`}/>
          ))}
        </div>
        <button data-testid="help-save" onClick={saveHelp} className="btn-primary-sf px-5 py-2 rounded-full text-sm font-semibold">Save</button>
      </section>
    </div>
  );
}
function Input({label,value,onChange,testid}){return <label className="block"><span className="block text-xs font-semibold uppercase text-slate-500 mb-1">{label}</span><input data-testid={testid} value={value||""} onChange={e=>onChange(e.target.value)} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2.5 text-sm"/></label>;}
function Textarea({label,value,onChange,testid,rows=4}){return <label className="block"><span className="block text-xs font-semibold uppercase text-slate-500 mb-1">{label}</span><textarea data-testid={testid} value={value||""} onChange={e=>onChange(e.target.value)} rows={rows} className="w-full bg-slate-50 border border-slate-200 rounded-xl px-3 py-2.5 text-sm"/></label>;}
